import ACTION_ITEMS from '../../../actionItems';

export function setSelectedTeam(team) {
  return {
    type: ACTION_ITEMS.TEAM_VIEWER.TEAMS.SELECTED,
    payload: team,
  };
}
